<template>
  <div class="l-base-layout">
    <l-header v-if="route.name !== 'landing'" />
    <banner />

    <sheet v-if="hideBreadcrumb">
      <pr-breadcrumb/>
    </sheet>
    <div class="router-view" :class="{'router-view--no-padding-bottom': noPaddingBottomPages}">
      <router-view />
    </div>

    <l-footer />
    <declare />
    <top />
  </div>
</template>
<script>
import { defineComponent, computed, onMounted } from 'vue';

import { useRoute, useRouter } from 'vue-router';
import LHeader from '@/layout/Header.vue';
import PrBreadcrumb from '@/components/Global/Breadcrumb.vue';
import Banner from '@/components/Global/Banner.vue';
import LFooter from '@/layout/Footer/index.vue';
import Top from '@/views/Base/Home/Top.vue';
import { useSiteStore } from '@/store/site';
import Declare from '@/layout/Footer/Declare.vue';

// import { getMetaAPI } from '@/api/meta';
import useMeta from '@/hooks/useMeta';

export default defineComponent({
  name: 'BaseLayout',
  components: {
    LHeader,
    PrBreadcrumb,
    LFooter,
    Banner,
    Top,
    Declare,
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const siteStore = useSiteStore();
    // const siteData = reactive({
    //   title: 'My website',
    //   description: 'My beautiful website',
    // });
    // const metaInfo = reactive([]);

    const { metaRequset } = useMeta();
    metaRequset();

    // useHead({
    //   // Can be static or computed
    //   title: computed(() => siteData.title),
    //   meta: metaInfo,
    // });

    const hideBreadcrumb = computed(() => {
      if (route.meta.hideBreadcrumb === true) {
        return false;
      }

      return true;
    });

    // 底部不推出 100px
    const noPaddingBottomPages = computed(() => {
      const noPaddingBottomPageList = ['history'];
      return noPaddingBottomPageList.includes(route.name);
    });

    const handleRoute = () => {
      if (!siteStore.isLogin && route.meta.auth) {
        router.push({ name: 'home' });
      }
    };

    onMounted(() => {
      handleRoute();
    });

    return {
      route,
      // tempFlag,
      hideBreadcrumb,
      noPaddingBottomPages,
    };
  },
});
</script>
<style lang="scss" scoped>
.l-base-layout {
  width: 100%;
  height: 100%;
}
.router-view {
  padding: 0 0 130px;

  &--no-padding-bottom {
    padding-bottom: 0;
  }
}
</style>
